import { styled } from '@styledComponents';
import { Box } from '@components/Box';
import { Text } from '@components/typography';
import { SmallTextStyles } from '@components/typography/interVariants';

export const FooterWrapper = styled(Box)`
  max-width: 330px;
  height: fit-content;
  text-align: center;
`;

export const StyledSvg = styled.svg`
  --fill-purple-dark: #975ad5;
  --fill-purple-light: #d49cdd;
  --fill-opacity: 0;

  @keyframes easeSocial {
    0% {
      opacity: 1;
    }
    25% {
      opacity: 0.65;
    }
    100% {
      opacity: 1;
    }
  }

  :hover {
    --fill-purple-dark: #d49cdd;
    --fill-purple-light: #975ad5;
    animation-name: easeSocial;
    animation-duration: 0.4s;
    animation-fill-mode: forwards;
  }

  :active {
    --fill-opacity: 0.2;
  }
`;

export const FooterText = styled(Text)`
  color: #767676;
  ${SmallTextStyles};
`;
